exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".baseTitle{background:#ff4438;font-style:normal;font-size:16px;line-height:32px;color:#fff}.baseTitle--default{font-weight:700;letter-spacing:.1em;text-align:center;padding:11px 0}.baseTitle--back{padding:7px 0 5px 50px;position:relative}.baseTitle--back .baseTitle__back{position:absolute;top:0;bottom:0;left:0;padding:10px 15px 10px 20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1b3d7102","scoped":false,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/utvStore/components/ChounDiary/partials/BaseTitle.vue
// module id = dqAT
// module chunks = 0